module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ih6Hj"))).then(() => module.bundle.root('lKlEc'));